export default __webpack_public_path__ + "static/media/hht1_song_05.eb8d1cc8.png";